import React, { useState } from 'react';

function App() {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Please enter your name.');
      return;
    }
    if (!mobile.trim() || mobile.length < 10) {
      setError('Please enter a valid mobile number.');
      return;
    }
    if (!password || password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    setSubmitted(true);
  };

  const handleReset = () => {
    setName('');
    setMobile('');
    setPassword('');
    setSubmitted(false);
    setError('');
  };

  return (
    <main className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {!submitted ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h1 className="text-2xl font-normal text-gray-900 mb-6 tracking-tight">Registration</h1>

            {error && (
              <div className="text-red-600 text-sm mb-2">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm text-gray-600 mb-1">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-black text-gray-900 text-sm"
                placeholder="Enter your name"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Mobile Number</label>
              <input
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-black text-gray-900 text-sm"
                placeholder="Enter mobile number"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-black text-gray-900 text-sm"
                placeholder="Enter password"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-black text-white py-2 rounded font-medium hover:bg-gray-800 transition-colors text-sm mt-2"
            >
              Submit
            </button>
          </form>
        ) : (
          <div className="text-center space-y-4">
            <h2 className="text-xl font-medium text-gray-900">Registration Successful</h2>
            <p className="text-sm text-gray-600">Welcome, {name}!</p>
            <button
              onClick={handleReset}
              className="w-full bg-black text-white py-2 rounded font-medium hover:bg-gray-800 transition-colors text-sm"
            >
              Register Another
            </button>
          </div>
        )}
      </div>
    </main>
  );
}

export default App;
